var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5 7.41035V22.0003H4.07997C2.91997 22.0003 1.96997 21.0703 1.96997 19.9303V5.09035C1.96997 2.47035 3.92997 1.28035 6.31997 2.45035L10.75 4.64035C11.71 5.11035 12.5 6.36035 12.5 7.41035Z",
    fill: "#3C435C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97 9.75H5.5C5.09 9.75 4.75 9.41 4.75 9C4.75 8.59 5.09 8.25 5.5 8.25H8.97C9.38 8.25 9.72 8.59 9.72 9C9.72 9.41 9.39 9.75 8.97 9.75Z",
    fill: "#3C435C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97 13.75H5.5C5.09 13.75 4.75 13.41 4.75 13C4.75 12.59 5.09 12.25 5.5 12.25H8.97C9.38 12.25 9.72 12.59 9.72 13C9.72 13.41 9.39 13.75 8.97 13.75Z",
    fill: "#3C435C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22 15.0499V19.4999C22 20.8799 20.88 21.9999 19.5 21.9999H12.5V10.4199L12.97 10.5199L17.01 11.4199L17.49 11.5299L19.53 11.9899C20.02 12.0899 20.47 12.2599 20.86 12.5099C20.86 12.5199 20.87 12.5199 20.87 12.5199C20.97 12.5899 21.07 12.6699 21.16 12.7599C21.62 13.2199 21.92 13.8899 21.99 14.8699C21.99 14.9299 22 14.9899 22 15.0499Z",
    fill: "#3C435C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.4199V16.4199C12.96 17.0299 13.68 17.4199 14.5 17.4199C15.89 17.4199 17.01 16.2999 17.01 14.9199V11.4299L12.97 10.5299L12.5 10.4199Z",
    fill: "#3C435C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.99 14.8699C21.92 13.8899 21.62 13.2199 21.16 12.7599C21.07 12.6699 20.97 12.5899 20.87 12.5199C20.87 12.5199 20.86 12.5199 20.86 12.5099C20.47 12.2599 20.02 12.0899 19.53 11.9899L17.49 11.5299L17.01 11.4199V14.9199C17.01 16.2899 18.12 17.4199 19.51 17.4199C20.85 17.4199 21.92 16.3699 22 15.0599V15.0499C22 14.9899 21.99 14.9299 21.99 14.8699Z",
    fill: "#3C435C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding1);
export default __webpack_public_path__ + "static/media/building-1.5a223a4d9cc04a07c263c9ee33c7e8d1.svg";
export { ForwardRef as ReactComponent };